import { takeEvery, all, put, select } from 'redux-saga/effects'
import { startSubmit, stopSubmit } from 'redux-form/immutable'
import { putActivity, deleteTempActivity } from '../actions'
import { push } from 'connected-react-router'
import i18next from 'i18next'
import { EDIT_ACTIVITY_FORM_NAME as FORM_NAME } from 'app/constants/activities'
import { showSuccess } from 'store/entities/toastr/utils'
import { getViewProtrackId } from 'store/entities/protracks/selectors'
import { getLevelsView } from 'store/entities/protracks/levels/selectors'
import { MICROACTIONS_PATH } from 'app/constants/navLinks'

export function* handlePutRequest() {
  yield put(startSubmit(FORM_NAME))
}

export function* handlePutSuccess({ payload: { data } }) {
  const protrackId = yield select(getViewProtrackId)
  const levelId = yield select(getLevelsView)
  yield put(deleteTempActivity(getLevelsView))
  yield put(
    push({
      pathname: `${MICROACTIONS_PATH}/protracks/${protrackId}/levels/${levelId}/activities`,
      state: { preventRequest: true, forceLeave: true },
    })
  )
  showSuccess({ content: i18next.t('You successfully updated activity', { name: data.name }) })
}

export function* handlePutFail(error) {
  console.error('error', error)
  yield put(stopSubmit(FORM_NAME))
}

export default function* putActivitySaga() {
  yield all([
    takeEvery(putActivity.toString(), handlePutRequest),
    takeEvery(putActivity.success.toString(), handlePutSuccess),
    takeEvery(putActivity.fail.toString(), handlePutFail),
  ])
}
